import React, { useEffect, useState } from "react";

// Components
import ReportButton from "./Elements/Button";
import ReportButtonList from "./Elements/ButtonList";
import ReportChart from "./Elements/ReportChart";
import SearchProduct from "./SearchProduct";
import RangeFilter from "../../../../common/components/RangeFilter";
import TableSkeleton from "../../../../common/TableSkeleton";

// Icons
const salesCountIcon        = `${EASYCOMMERCE.assets}admin/img/icons/reports/sales-count.png`;
const salesAmountIcon       = `${EASYCOMMERCE.assets}admin/img/icons/reports/sales-amount.png`;
const marginAmountIcon      = `${EASYCOMMERCE.assets}admin/img/icons/reports/profit-amount.png`;
const refuntCountIcon       = `${EASYCOMMERCE.assets}admin/img/icons/reports/refund-count.png`;
const refuntAmountIcon      = `${EASYCOMMERCE.assets}admin/img/icons/reports/refund-amount.png`;
const completedCountIcon    = `${EASYCOMMERCE.assets}admin/img/icons/reports/completed-count.png`;
const completedAmountIcon   = `${EASYCOMMERCE.assets}admin/img/icons/reports/completed-amount.png`;
const pendingCountIcon      = `${EASYCOMMERCE.assets}admin/img/icons/reports/pending-count.png`;
const pendingAmountIcon     = `${EASYCOMMERCE.assets}admin/img/icons/reports/pending-amount.png`;
const processingCountIcon   = `${EASYCOMMERCE.assets}admin/img/icons/reports/processing-count.png`;
const processingAmountIcon  = `${EASYCOMMERCE.assets}admin/img/icons/reports/processing-amount.png`;
const onholdCountIcon       = `${EASYCOMMERCE.assets}admin/img/icons/reports/onhold-count.png`;
const onholdAmountIcon      = `${EASYCOMMERCE.assets}admin/img/icons/reports/onhold-amount.png`;
const cancelledCountIcon    = `${EASYCOMMERCE.assets}admin/img/icons/reports/cancelled-count.png`;
const cancelledAmountIcon   = `${EASYCOMMERCE.assets}admin/img/icons/reports/cancelled-amount.png`;

const tabs = [
    {
        id: "sales-count",
        icon: salesCountIcon,
        title: "",
        subtitle: "Sales Count",
        isActive: true,
        activeRightBorderColor: "border-r-[#88CD44]",
        type : "count",
    },
    {
        id: "sales-amount",
        icon: salesAmountIcon,
        title: "",
        subtitle: "Sales Amount",
        isActive: true,
        activeRightBorderColor: "border-r-[#7AAA49]",
        type : "amount",
    },
    {
        id: "margin-amount",
        icon: marginAmountIcon,
        title: "",
        subtitle: "Profit Amount",
        isActive: true,
        activeRightBorderColor: "border-r-[#009D68]",
        type : "amount",
    },
    {
        id: "refund-count",
        icon: refuntCountIcon,
        title: "",
        subtitle: "Refund Count",
        isActive: true,
        activeRightBorderColor: "border-r-[#7A59FF]",
        type : "count",
    },
    {
        id: "refund-amount",
        icon: refuntAmountIcon,
        title: "",
        subtitle: "Refund Amount",
        isActive: true,
        activeRightBorderColor: "border-r-[#5433DA]",
        type : "amount",
    },
    {
        id: "completed-count",
        icon: completedCountIcon,
        title: "",
        subtitle: "Completed Count",
        isActive: false,
        activeRightBorderColor: "border-r-[#19AA79]",
        type : "count",
    },
    {
        id: "completed-amount",
        icon: completedAmountIcon,
        title: "",
        subtitle: "Completed Amount",
        isActive: false,
        activeRightBorderColor: "border-r-[#0A875D]",
        type : "amount",
    },
    {
        id: "pending-count",
        icon: pendingCountIcon,
        title: "",
        subtitle: "Pending Count",
        isActive: false,
        activeRightBorderColor: "border-r-[#FD7F51]",
        type : "count",
    },
    {
        id: "pending-amount",
        icon: pendingAmountIcon,
        title: "",
        subtitle: "Pending Amount",
        isActive: false,
        activeRightBorderColor: "border-r-[#D55D31]",
        type : "amount",
    },
    {
        id: "processing-count",
        icon: processingCountIcon,
        title: "",
        subtitle: "Processing Count",
        isActive: false,
        activeRightBorderColor: "border-r-[#B759FF]",
        type : "count",
    },
    {
        id: "processing-amount",
        icon: processingAmountIcon,
        title: "",
        subtitle: "Processing Amount",
        isActive: false,
        activeRightBorderColor: "border-r-[#9427E8]",
        type : "amount",
    },
    {
        id: "onhold-count",
        icon: onholdCountIcon,
        title: "",
        subtitle: "Onhold Count",
        isActive: false,
        activeRightBorderColor: "border-r-[#5283FF]",
        type : "count",
    },
    {
        id: "onhold-amount",
        icon: onholdAmountIcon,
        title: "",
        subtitle: "Onhold Amount",
        isActive: false,
        activeRightBorderColor: "border-r-[#2356D7]",
        type : "amount",
    },
    {
        id: "cancelled-count",
        icon: cancelledCountIcon,
        title: "",
        subtitle: "Cancelled Count",
        isActive: false,
        activeRightBorderColor: "border-r-[#FF598E]",
        type : "count",
    },
    {
        id: "cancelled-amount",
        icon: cancelledAmountIcon,
        title: "",
        subtitle: "Cancelled Amount",
        isActive: false,
        activeRightBorderColor: "border-r-[#E24476]",
        type : "count",
    },
];


const OrdersReport = () => {
    const [range, setRange] = useState("this-month");
    const [customRange, setCustomRange] = useState({
        from: "",
        to: "",
    });
    const [activeChartIds, setActiveChartIds] = useState( ['sales-count', 'sales-amount', 'margin-amount', 'refund-count', 'refund-amount'] );
    const [reportTabs, setReportTaabs] = useState(tabs);
    const [isLoading, setIsLoading] = useState(true);
    const [labels, setLabels] = useState([]);
    const [datasets, setDatasets] = useState([]);

    const [productName, setProductName] = useState("");
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [filterLabel, setFilterLabel] = useState("This Month");

    const handleProductSelect = (title, id) => {
        setProductName(title);
        setSelectedProductId(id);

        setIsLoading(true);
        let url = `${EASYCOMMERCE.rest_base}/dashboard/reports?product_id=${id}`;
        fetchReports(url);
    };

    const updateReportTabs = (index) => {
        const tabs = [...reportTabs];

        tabs[index].isActive = !tabs[index].isActive;

        // set current active indexes
        const activeIds = [];
        tabs.forEach((report, i) => {
            if (report.isActive) {
                activeIds.push(report.id);
            }
        });

        setActiveChartIds(activeIds);
        setReportTaabs(tabs);
    };

    const handleRange = (value) => {
        setRange(value);
        setCustomRange({ from: "", to: "" });
    };

    const handleCustomRange = (key, value) => {
        setRange(null);
        setCustomRange({ ...customRange, [key]: value });
    };

    const fetchReports = (url) => {
        if (url.match(/range=/) || (url.match(/from=/) && url.match(/to=/))) {
            fetch(url,{
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": EASYCOMMERCE.nonce,
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success && data.data?.reports) {
                        const updatedTabs = reportTabs.map((tab) => {
                            const matchingDataset =
                                data.data.reports.datasets.find(
                                    (dataset) => dataset.id === tab.id
                                );

                            if (matchingDataset) {
                                tab.title = `${matchingDataset.total}`;
                            }

                            return tab;
                        });

                        setLabels(data.data.reports.labels);
                        setDatasets(data.data.reports.datasets);

                        setReportTaabs(updatedTabs);
                        setIsLoading(false);
                    }
                });
        } else {
            return;
        }
    };

    useEffect(() => {
        if (
            (!customRange.from && customRange.to) ||
            (customRange.from && !customRange.to)
        )
            return;

        if (
            !selectedProductId &&
            !range &&
            (!customRange.from || !customRange.to)
        )
            return;

        let url = `${EASYCOMMERCE.rest_base}/dashboard/reports`;

        const params = new URLSearchParams();

        if (selectedProductId) {
            params.set("product_id", selectedProductId);
        }

        if (customRange.from && customRange.to) {
            params.set("from", customRange.from);
            params.set("to", customRange.to);
        } else if (range) {
            params.set("range", range);
        }

        url += `?${params.toString()}`;

        setIsLoading(true);
        fetchReports(url);
    }, [range, customRange.from, customRange.to, selectedProductId]);

    return (
        <div className="w-full h-full flex items-start justify-between gap-5 bg-white">
            <ReportButtonList title={"Orders"}>
                {!isLoading ? (
                    reportTabs.map((tab, index) => (
                        <ReportButton
                            key={tab.title}
                            icon={tab.icon}
                            title={tab.title}
                            subtitle={tab.subtitle}
                            isActive={tab.isActive}
                            activeRightBorderColor={tab.activeRightBorderColor}
                            type = {tab.type}
                            handleClick={
                                !isLoading
                                    ? () => updateReportTabs(index)
                                    : () => {}
                            }
                        />
                    ))
                ) : (
                    <div className="w-[95%] mx-auto">
                        <TableSkeleton SkeletonHeight={70} numberOfRows={9} />
                    </div>
                )}
            </ReportButtonList>

            <div className="col-span-10 border border-ec-border rounded-lg p-6 w-[calc(100%_-_330px)]">
                {!isLoading && (
                    <div className="flex justify-end items-center gap-4">
                        <SearchProduct
                            productName={productName}
                            handleProductSelect={handleProductSelect}
                        />

                        <RangeFilter
                            range={range}
                            customRange={customRange}
                            filterLabel={filterLabel}
                            handleRange={handleRange}
                            handleFilterLabel={(str) => setFilterLabel(str)}
                            handleCustomRange={handleCustomRange}
                        />
                    </div>
                )}

                <div className="w-full">
                    {!isLoading ? (
                        <ReportChart
                            activeIds={activeChartIds}
                            labels={labels}
                            datasets={datasets}
                        />
                    ) : (
                        <TableSkeleton SkeletonHeight={30} numberOfRows={10} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default OrdersReport;
